"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = exports.getCrumbId = void 0;
var react_1 = __importStar(require("react"));
var design_system_typography_1 = require("@contrast-security-inc/design-system-typography");
var css_1 = require("@emotion/css");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var messages = __importStar(require("../translations"));
var breadcrumbsStyle = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline;\n\n  ol {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n\n    li {\n      display: inline-block;\n      white-space: nowrap;\n\n      &.ds-breadcrumb-separator {\n        user-select: none;\n      }\n\n      &:not(:last-child) {\n        margin-right: 16px;\n      }\n    }\n  }\n"], ["\n  display: inline;\n\n  ol {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n\n    li {\n      display: inline-block;\n      white-space: nowrap;\n\n      &.ds-breadcrumb-separator {\n        user-select: none;\n      }\n\n      &:not(:last-child) {\n        margin-right: 16px;\n      }\n    }\n  }\n"])));
var getCrumbId = function (item) { var _a, _b, _c; return (_a = item.id) !== null && _a !== void 0 ? _a : "".concat(item.label).concat((_c = (_b = item.linkProps) === null || _b === void 0 ? void 0 : _b.href) !== null && _c !== void 0 ? _c : ''); };
exports.getCrumbId = getCrumbId;
exports.Breadcrumbs = (0, react_1.forwardRef)(function (_a, ref) {
    var className = _a.className, testId = _a.testId, style = _a.style, crumbs = _a.crumbs, _b = _a.separator, separator = _b === void 0 ? '/' : _b, rest = __rest(_a, ["className", "testId", "style", "crumbs", "separator"]);
    var separatedCrumbs = (0, react_1.useMemo)(function () {
        return crumbs === null || crumbs === void 0 ? void 0 : crumbs.reduce(function (acc, crumb, index) {
            var _a;
            var crumbId = (0, exports.getCrumbId)(crumb);
            // Add separator between crumbs
            if (index > 0) {
                var separatorId = "crumb-separator-".concat(crumbId);
                acc.push(react_1.default.createElement("li", { "data-testid": separatorId, className: "ds-breadcrumbs-separator", "aria-hidden": true, key: separatorId },
                    react_1.default.createElement(design_system_typography_1.Text, { font: 'titleH3' }, separator)));
            }
            // Add crumb
            var isLast = index === crumbs.length - 1;
            var _b = (_a = crumb === null || crumb === void 0 ? void 0 : crumb.linkProps) !== null && _a !== void 0 ? _a : {}, _c = _b.font, font = _c === void 0 ? 'titleH3' : _c, linkProps = __rest(_b, ["font"]);
            acc.push(react_1.default.createElement("li", __assign({ "data-testid": "crumb-".concat(crumbId), className: "ds-breadcrumbs-crumb" }, (isLast && { 'aria-current': 'page' }), { key: "crumb-".concat(crumbId) }), crumb.linkProps ? (react_1.default.createElement(design_system_typography_1.Link, __assign({ font: font }, linkProps), crumb.label)) : (react_1.default.createElement(design_system_typography_1.Text, { font: "titleH3" }, crumb.label))));
            return acc;
        }, []);
    }, [crumbs, separator]);
    return (react_1.default.createElement("nav", __assign({ "data-testid": testId, style: style, ref: ref, "aria-label": (0, design_system_foundations_1.formatMessage)(messages, 'Breadcrumbs'), className: (0, css_1.cx)(breadcrumbsStyle, className, 'ds-breadcrumbs') }, rest),
        react_1.default.createElement("ol", { className: "ds-breadcrumbs-list" }, separatedCrumbs)));
});
exports.Breadcrumbs.displayName = 'Breadcrumbs';
var templateObject_1;
